import React, { useState, useEffect } from 'react';
import { settingsFunctions } from '../../../functions/settings';
import enterpriseAPI from '../../../utils/API/enterpriseAPI';
import { useAuth } from '../../../utils/Auth';
import { Link } from 'react-router';
import Collapse from 'react-bootstrap/Collapse';
import styles from './Scheduling.module.css';

export default function Scheduling() {

    const { updateVcardObject } = settingsFunctions;
    const { getUpdatedUserVcard, userObj, vcardObj } = useAuth();
    const { permissions, enterprise, uid } = userObj;
    const { scheduling } = vcardObj;

    const [ show, setShow ] = useState(false);
    const [ loading, setLoading ] = useState(false);
    const [ state, setState ] = useState({
        greeting: scheduling?.greeting || '',
        calendly_url: scheduling?.calendly_url || '',
        enabled: scheduling?.enabled || false,
        error: '',
        success: ''
    });

    const handleSave = async () => {
        setLoading(true);

        if (state.calendly_url) {
            let userEdit = {
                scheduling: {
                    greeting: state.greeting || 'Schedule a meeting!',
                    calendly_url: state.calendly_url,
                    enabled: state.enabled
                }
            };
    
            try {
                if (enterprise) await enterpriseAPI.updateEnterpriseAccount(uid, {scheduling: state.calendly_url});
                await updateVcardObject(userEdit, userObj.uid)
                await getUpdatedUserVcard()
                setState(prev => ({ ...prev, success: 'Scheduling settings updated successfully' }));
            } catch (error) {
                setState(prev => ({...prev, error: 'Scheduling could not be updated.'}))
            } finally {
                setLoading(false);
            };
        } else {
            setLoading(false);
        };
    };

    useEffect(() => {
        if (state.error || state.success) {
            const timer = setTimeout(() => {
                setState(prev => ({...prev, error: '', success: ''}));
            },3000);
            return () => clearTimeout(timer);
        };
    },[state.error, state.success])

    const handleReturn = () => {
        if (!permissions?.scheduling) {
            return enterprise ? (
                <p className={styles.schedulingDenied}>
                    Speak with your Administrator for access to these settings.
                </p>
            ) : (
                <p className={styles.schedulingGranted}>
                    <Link to='/upgrade' className={styles.upgrade}>Upgrade to Pro</Link>
                    to start using Calendly
                </p>
            )
        } else {
            return (
                <>
                <div className={styles.inputGroup} style={{flexDirection: 'column'}}>
                    <label htmlFor='calendly-greeting' className={styles.label}>Greeting</label>
                    <input 
                        type='text' 
                        className={styles.input} 
                        value={state.greeting} 
                        onChange={e => setState(prev => ({...prev, greeting: e.target.value}))} 
                        maxLength='30'
                        id='calendly-greeting'
                    />
                </div>
                <div className={styles.inputGroup} style={{flexDirection: 'column'}}>
                    <label htmlFor='calendly-url' className={styles.label}>Calendly URL</label>
                    <input
                        type='url'
                        className={styles.input}
                        value={state.calendly_url}
                        onChange={e => setState(prev => ({...prev, calendly_url: e.target.value}))}
                        disabled={!permissions.scheduling}
                    />
                    {!scheduling && <p className={styles.newToScheduling}>New to Calendly? Sign up <a href='https://www.calendly.com' target='_blank' rel='noreferrer' className='calendly-link' style={{fontSize: '.8rem'}}>HERE</a></p>}
                </div>
                <div className={styles.inputGroup}>
                    <input
                        type='checkbox'
                        id='calendly-enable'
                        className={styles.inputCheck}
                        checked={state.enabled}
                        onChange={e => setState(prev => ({...prev, enabled: e.target.checked}))}
                        disabled={!permissions.scheduling || !state.calendly_url}
                    />
                    <label htmlFor='calendly-enable' className={styles.labelCheck}>Enable Calendly</label>
                </div>
                <div className={styles.inputGroup} style={{flexDirection: 'column'}}>
                    <label className={styles.label}>Save</label>
                    <button className={styles.saveBtn} onClick={handleSave} disabled={!permissions.scheduling || !state.calendly_url || loading}>
                        {loading ?
                            <i className='fa-thin fa-spinner fa-spin-pulse' />
                        : "Save Calendly Settings"}
                    </button>
                    {(state.error || state.success) ?
                        <div className={styles.message} style={state.error ? {color: 'red'} : {color: 'green'}}>{state.error || state.success}</div>
                        : <></>
                    }
                </div>
                </>
            )
        }
    }

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <div className={styles.headerInner}>
                    <div className={styles.title}>Scheduling</div>
                    <div className={styles.subtitle}>Powered by Calendly</div>
                </div>
                <button className={!show ? styles.collapseBtn : `${styles.collapseBtn} ${styles.open}`} onClick={() => setShow(!show)}>
                    <i className='fas fa-chevron-down' />
                </button>
            </div>
            <Collapse in={show}>
                <div className={styles.position}>
                    <div className={styles.content}>
                        {handleReturn()}
                    </div>
                </div>
            </Collapse>
        </div>
    );
};